<div
  class="compatability-page col-sm-12 align-self-center pl-0 flow home-header-page honecompatability-page"
>
  <div class="col-12 p-0">
    <div class="row m-0 p-0">
      <div
        [hidden]="this.screenWidth <= 1024"
        class="row col-12 p-0 mt-4 mb-4 navigation-arrow-text back-phone-link bt-back-page"
        (click)="backToBluetoothPage()"
      >
        <span
          class="material-icons color-app bt-back-link"
          style="vertical-align: middle"
          >chevron_left</span
        >
        <span class="back-phone-text">Back</span>
      </div>
      <!-- VIN Input Card -->
      <mat-card
        *ngIf="showVinInput"
        class="col-12 desktop-model-year-vin-selection"
        [hidden]="this.screenWidth <= 1024"
      >
        <div class="row pl-0 col-12 d-flex">
          <div
            class="col-12 desktop-model-year-vin-selection"
            [hidden]="this.screenWidth <= 1024"
          >
            <form [formGroup]="searchForm">
              <div class="form-group d-flex mt-10">
                <div class="d-flex">
                  <mat-form-field
                    appearance="outline"
                    class="container-auto flex-grow-1"
                  >
                    <input
                      (input)="onVinKeyup($event.target.value)"
                      matInput
                      minLength="17"
                      maxLength="17"
                      class="vin-textbox"
                      placeholder="ENTER 17 DIGIT VIN"
                      [ngClass]="{ 'invalid-vin': vinError }"
                      formControlName="vin"
                      type="text"
                      aria-live="off"
                    />
                  </mat-form-field>
                  <div class="ml-3">
                    <button
                      type="button"
                      (click)="onSearch()"
                      class="btn getstarted-btn"
                    >
                      Search
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div *ngIf="vinError" class="bt-error-message text-center">
            Please enter a valid 17-digit VIN.
          </div>
          <div class="bt-error-message text-center" *ngIf="compatabilityNotAvailable">
           
                <span>{{"Message.PHONE_COMPATABILITY_MESSAGE" | translate}}</span>
            </div>
        
        
            <div class="bt-error-message text-center" *ngIf="vinInOtherDivisionError">
                <span *ngIf="appName === 'lexus'" >
                    Sorry, This is a Toyota VIN. Please enter a valid Lexus VIN.
                </span>
                <span *ngIf="appName !== 'lexus'">
                    Sorry, This is a Lexus VIN. Please enter a valid Toyota VIN.
                </span>
        </div>
        </div>
      </mat-card>

      <!-- Manufacturer and Model Selection Form -->
      <mat-card
        *ngIf="showManufacturerModelSelection"
        class="col-12 desktop-model-year-vin-selection"
        [hidden]="this.screenWidth <= 1024"
      >
        <div class="row pl-0 col-12 d-flex">
          <div
            class="col-12 desktop-model-year-vin-selection"
            [hidden]="this.screenWidth <= 1024"
          >
            <form
              *ngIf="manufacturerForm"
              [formGroup]="manufacturerForm"
              novalidate
              name="manufacturerForm"
            >
              <div class="form-group d-flex mt-10">
                <div class="d-flex">
                  <div
                    [ngClass]="{
                      'dropdown-toyota-wrapper': appName === 'toyota'
                    }"
                  >
                    <select
                      id="manufacturer"
                      formControlName="manufacturer"
                      name="manufacturer"
                      class="header-dropdown"
                      [ngClass]="{
                        'is-invalid-selection':
                          isSubmitted &&
                          manufacturerForm.controls['manufacturer'].value === ''
                      }"
                      (change)="onManufaturerChange($event)"
                      required
                    >
                      <option value="">
                        {{ "Label.select_manufacturer" | translate }}
                      </option>
                      <option
                        *ngFor="let manufacturers of phoneManufacturerList"
                        value="{{ manufacturers.manufacturerId }}"
                        [ngClass]="{ capitalize: appName === 'toyota' }"
                      >
                        {{ manufacturers.manufacturerName }}
                      </option>
                    </select>
                  </div>

                  <div class="ml-3">
                    <select
                      [disabled]="manufacturerForm.controls['phoneModel'].value"
                      [ngClass]="{
                        'is-invalid-selection':
                          isSubmitted &&
                          manufacturerForm.controls['manufacturer'].value !=
                            '' &&
                          manufacturerForm.controls['phoneModel'].value === ''
                      }"
                      formControlName="phoneModel"
                      name="phoneModel"
                      class="header-dropdown model-name"
                      (change)="onPhoneModelChange($event)"
                    >
                      <option value="">
                        {{ "Label.select_phone_model" | translate }}
                      </option>
                      <option
                        *ngFor="let phoneModels of phoneModelList"
                        [value]="phoneModels.phoneConfigId"
                      >
                        {{ phoneModels.phoneModelName }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="ml-3">
                  <button
                    type="button"
                    name="continue"
                    [disabled]="!manufacturerForm.valid"
                    (click)="openCompatabiltyDashBoard()"
                    class="btn getstarted-btn"
                  >
                    {{ "Button.continue" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </mat-card>

      <div
        class="responsive-model-year-vin-selection col-12 p-10 m-0"
        [hidden]="this.screenWidth > 1024"
      >
        <div
          class="row col-12 p-0 mt-4 mb-4 ml-2 navigation-arrow-text back-phone-link bt-back-page"
          (click)="backToBluetoothPage()"
        >
          <span
            class="material-icons color-app bt-back-link"
            style="vertical-align: middle"
            >chevron_left</span
          >
          <span class="back-phone-text">Back</span>
        </div>
        <div class="row p-0 m-0 col-12" [hidden]="this.screenWidth > 1024">
          <div class="form-group col-12 p-0">
            <form [formGroup]="searchForm" *ngIf="showVinInput">
              <div class="column-container">
                <div>
                  <mat-form-field
                    appearance="outline"
                    class="container-auto flex-grow-1"
                  >
                    <input
                      (input)="onVinKeyup($event.target.value)"
                      matInput
                      minLength="17"
                      maxLength="17"
                      class="vin-textbox"
                      placeholder="ENTER 17 DIGIT VIN"
                      [ngClass]="{ 'invalid-vin': vinError }"
                      formControlName="vin"
                      type="text"
                      aria-live="off"
                    />
                  </mat-form-field>

                  <div class="ml-3">
                    <button
                      type="button"
                      (click)="onSearch()"
                      class="btn getstarted-btn"
                    >
                      Search
                    </button>

                    <div *ngIf="vinError" class="bt-error-message text-center">
                      Please enter a valid 17-digit VIN.
                    </div>
                    <div class="bt-error-message text-center" *ngIf="compatabilityNotAvailable">
                     
                          <span>{{"Message.PHONE_COMPATABILITY_MESSAGE" | translate}}</span>
                   
                  </div>
               
                      <div class="bt-error-message text-center" *ngIf="vinInOtherDivisionError">
                        <span *ngIf="appName === 'lexus'" >
                          Sorry, This is a Toyota VIN. Please enter a valid Lexus VIN.
                      </span>
                      <span *ngIf="appName !== 'lexus'">
                          Sorry, This is a Lexus VIN. Please enter a valid Toyota VIN.
                      </span>
                      </div>
               
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div *ngIf="showManufacturerModelSelection">
            <form
              *ngIf="manufacturerForm"
              [formGroup]="manufacturerForm"
              class="col-12 p-10"
              novalidate
              name="manufacturerForm"
            >
              <div class="form-group col-12 p-0">
                <div>
                  <select
                    id="manufacturer"
                    formControlName="manufacturer"
                    name="manufacturer"
                    class="header-dropdown"
                    [ngClass]="{
                      'is-invalid-selection':
                        isSubmitted &&
                        manufacturerForm.controls['manufacturer'].value === ''
                    }"
                    (change)="onManufaturerChange($event)"
                    required
                  >
                    <option value="">
                      {{ "Label.select_manufacturer" | translate }}
                    </option>
                    <option
                      *ngFor="let manufacturers of phoneManufacturerList"
                      value="{{ manufacturers.manufacturerId }}"
                      [ngClass]="{ capitalize: appName === 'toyota' }"
                    >
                      {{ manufacturers.manufacturerName }}
                    </option>
                  </select>
                </div>

                <div>
                  <select
                    [disabled]="manufacturerForm.controls['phoneModel'].value"
                    [ngClass]="{
                      'is-invalid-selection':
                        isSubmitted &&
                        manufacturerForm.controls['manufacturer'].value != '' &&
                        manufacturerForm.controls['phoneModel'].value === ''
                    }"
                    formControlName="phoneModel"
                    name="phoneModel"
                    class="header-dropdown model-name"
                    (change)="onPhoneModelChange($event)"
                  >
                    <option value="">
                      {{ "Label.select_phone_model" | translate }}
                    </option>
                    <option
                      *ngFor="let phoneModels of phoneModelList"
                      [value]="phoneModels.phoneConfigId"
                    >
                      {{ phoneModels.phoneModelName }}
                    </option>
                  </select>
                </div>
                <div class="">
                  <button
                    type="button"
                    name="continue"
                    [disabled]="!manufacturerForm.valid"
                    (click)="openCompatabiltyDashBoard()"
                    class="btn getstarted-btn"
                  >
                    {{ "Button.continue" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
